export default {
    props: {
        hidden: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {};
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
        show: function () {
            this.$el.style.display = '';
        },
        hide: function () {
            this.$el.style.display = 'none';
        }
    }
};
